// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15mTs","clinicsSelect":"styles_clinicsSelect__2p276"};